import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'qs';

import JournalTable from '../../common/JournalTable';
import PageTitle from '../../common/PageTitle';

import { fetchGetOrdersExportTasks, fetchGetOrdersReportById } from '../../../actions/orders';

import { ORDERS_EXPORT_PAGE_LABELS, ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const ExportPage = () => {
  const history = useHistory();

  const [exportType, setExportType] = useState(null);

  const { t } = useAutoTranslation();

  useEffect(() => {
    const params = qs.parse(history.location.search.slice(1));
    if (params.export_type) {
      setExportType(params.export_type);
    }
  }, [history.location.search]);

  const handleGetTaskData = (taskData) => {
    let result = [];
    if (taskData.requestJson) {
      const parsed = JSON.parse(taskData.requestJson);
      result = [
        ...Object.keys(parsed)
          .map((key) => ({
            label: ORDERS_EXPORT_PAGE_LABELS[key],
            value: (() => {
              if (key === 'searchDateType') {
                return ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS.find((o) => o.value === parsed[key])
                  .label;
              }
              return typeof parsed[key] === 'boolean' ? (parsed[key] ? 'Да' : 'Нет') : parsed[key];
            })(),
          }))
          .filter((i) => i.label),
      ];
    }
    return result;
  };

  const handleShowReport = (task) => task.processingLog && task.processingLog.length;
  const handleShowSuccessReport = (task) => !handleShowReport(task) && task.fileUrl;

  return (
    <>
      <PageTitle title={t('Задачи экспорта заказов')} />

      <JournalTable
        matchingWithName
        processedLabel={t('Экспортировано')}
        newTaskLabel={t('Новый экспорт')}
        newTaskUrl={`/orders-export/new${exportType ? '?export_type=' + exportType : ''}`}
        taskName={t('Экспорт заказов (Excel)')}
        getTaskData={handleGetTaskData}
        getTasksAction={fetchGetOrdersExportTasks}
        getTaskDataAction={fetchGetOrdersReportById}
        showSummary={false}
        detailsTitle={t('Опции экспорта')}
        showReport={handleShowReport}
        showSuccessReport={handleShowSuccessReport}
        reportUrl="/orders-export/report"
        taskTimePropName="startTime"
      />
    </>
  );
};

export default ExportPage;
